import * as React from 'react'

import { ArcadeIcon, HelpFillIcon } from '@arcade/web/icons/react'

import ArcadeButton from '../Arcade/Button/ArcadeButton'

export type ArcadeHelperTextProps = {
  /**
   * Required: Text to display on helper text
   */
  tooltipText: string
  /**
   * Required: Callback function when helper text is clicked
   */
  onClick: () => void
}

const ArcadeHelperText = React.forwardRef<HTMLButtonElement, ArcadeHelperTextProps>(({ tooltipText, onClick }, ref) => (
  <ArcadeButton prominence="standard" onClick={onClick} Icon={HelpFillIcon as ArcadeIcon} size="compact" ref={ref}>
    {tooltipText}
  </ArcadeButton>
))

export default ArcadeHelperText
